/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prefer-destructuring */
import React, { useContext, useEffect, useState } from 'react'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'
import { useNavigate, useLocation } from 'react-router-dom'

import { ReactComponent as LogoJB } from 'assets/images/main-logo-jb.svg'
import { ReactComponent as LogoLepain } from 'assets/images/main-logo-le-pain.svg'
import { removeAuthHeader } from 'utils'
import { UserContext } from 'contexts'
import { ReactComponent as LogoTEA } from 'assets/images/main-logo-tea.svg'
import { ReactComponent as LogoGE } from 'assets/images/main-logo-ge.svg'
import { ReactComponent as LogoTS } from 'assets/images/main-logo-ts.svg'
import { ReactComponent as LogoCS } from 'assets/images/main-logo-casa-saenz.svg'
import { ReactComponent as LogoPARU } from 'assets/images/main-logo-paru.svg'
import { ReactComponent as LogoRonnie } from 'assets/images/main-logo-ronnie.svg'
import { ReactComponent as LogoClubMila } from 'assets/images/main-logo-club-mila.svg'
import { ReactComponent as LogoVicolo } from 'assets/images/main-logo-vicolo.svg'
import { ReactComponent as LogoSignoraMariola } from 'assets/images/main-logo-signora-mariola.svg'
import { ReactComponent as LogoAcaiBrasil } from 'assets/images/main-logo-acai-brasil.svg'
import { ReactComponent as LogoLaCondesa } from 'assets/images/main-logo-la-condesa.svg'
import { ReactComponent as LogoElDiez } from 'assets/images/main-logo-el-diez.svg'
import { useApiCall } from 'hooks'
import { GetStyleResponse } from 'features/Main/Styles/types'
import { getStyles } from 'features/Main/Styles/api'
import { ConfigUtils } from 'utils/config'

import { useStyles } from './styles'

interface Props {
  isLoggedIn?: boolean
}

const NavBar: React.FC<Props> = ({ isLoggedIn }) => {
  const classes = useStyles()
  const { setAdmin } = useContext(UserContext)
  const navigate = useNavigate()
  const location = useLocation()

  const onLogout = () => {
    localStorage.clear()
    removeAuthHeader()
    setAdmin(undefined)
    navigate('/login', { state: { from: location } })
  }

  const [styleApi] = useApiCall<void, GetStyleResponse>(getStyles)
  const [logoUrl, setLogoUrl] = useState('')
  const [isThemeLoading, setIsThemeLoading] = useState(true)

  useEffect(() => {
    const fetchTheme = async () => {
      try {
        const response = await styleApi()
        const style = response.style
        setLogoUrl(style.logoUrl)
        setIsThemeLoading(false)
      } catch (error) {
        setIsThemeLoading(false)
        console.error('Error fetching theme data:', error)
      }
    }

    fetchTheme()
  }, [])

  const getNavbarLogo = () => {
    if (isThemeLoading) return null
    if (logoUrl) return <img src={logoUrl} alt="Logo" className={classes.logo} />

    if (ConfigUtils.isApp('tea')) return <LogoTEA height={50} width={200} />
    if (ConfigUtils.isApp('ge')) return <LogoGE height={50} width={200} />
    if (ConfigUtils.isApp('le-pain-quotidien')) return <LogoLepain height={15} width={224} />
    if (ConfigUtils.isApp('cs')) return <LogoCS height={50} width={200} />
    if (ConfigUtils.isApp('paru')) return <LogoPARU height={50} width={200} />
    if (ConfigUtils.isApp('jb')) return <LogoJB height={50} width={200} />
    if (ConfigUtils.isApp('ts')) return <LogoTS height={50} width={200} />
    if (ConfigUtils.isApp('ronnie')) return <LogoRonnie height={45} width={180} />
    if (ConfigUtils.isApp('cm')) return <LogoClubMila height={50} width={200} />
    if (ConfigUtils.isApp('vicolo')) return <LogoVicolo height={50} width={200} />
    if (ConfigUtils.isApp('signora-mariola')) return <LogoSignoraMariola height={50} width={200} />
    if (ConfigUtils.isApp('acai-brasil')) return <LogoAcaiBrasil height={46} width={220} />
    if (ConfigUtils.isApp('la-condesa')) return <LogoLaCondesa height={50} width={116} />
    if (ConfigUtils.isApp('el-diez')) return <LogoElDiez height={50} width={180} />

    return <LogoGE height={50} width={200} />
  }

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar>
        {getNavbarLogo()}
        {isLoggedIn && (
          <Button color="inherit" className={classes.logout} onClick={onLogout}>
            Cerrar sesión
          </Button>
        )}
      </Toolbar>
    </AppBar>
  )
}

NavBar.defaultProps = {
  isLoggedIn: false,
}

export { NavBar }
